import { Flex, Skeleton, Typography } from 'antd';

import { PREFIX } from '@app/constants';
import type { OrganizationInfoProps } from '@app/pages/Users/UserProfile/components/OrganizationInfo/types';

const { Text } = Typography;

export const OrganizationInfo: React.FC<OrganizationInfoProps> = ({
  isLoading,
  currentUser,
}) => {
  if (isLoading) {
    return <Skeleton active />;
  }

  const { Organization } = currentUser;

  return (
    <div className={`${PREFIX}organization-info`}>
      <Flex vertical gap={8}>
        <Flex gap={20}>
          <Text strong>Название</Text>
          <Text>{Organization?.Name || 'Название не указано'}</Text>
        </Flex>
        <Flex gap={68}>
          <Text strong>ID</Text>
          <Text>{Organization?.Id || 'ID не указан'}</Text>
        </Flex>
      </Flex>
    </div>
  );
};
